import React from 'react';
import PropTypes from 'prop-types';

const ScrollableItemsList = ({ items, maxHeight = '200px' }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const containerStyles = {
    maxHeight,
    overflowY: 'auto',
    padding: '8px',
    marginBottom: '16px',
    marginLeft: '45px',
  };

  const itemStyles = {
    margin: '4px 0',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'left',
  };

  return (
    <div style={containerStyles}>
      <ul>
        {items.map(item => (
          <li key={`scrollable-item-${item}`} style={itemStyles}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

ScrollableItemsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  maxHeight: PropTypes.string,
};

ScrollableItemsList.defaultProps = {
  maxHeight: '200px',
};

export default ScrollableItemsList;
